export default __webpack_public_path__ + "static/usd-arrived-e6fab25555682b44965d0bb3a6319686.svg";